<template>
<div>
    <RichResponseHeadline
        v-if="!!headline"
        :title="headline"
    >
        <template v-slot:right>
            <ShareButton
                text-only
                with-icon
                :lines="prepareForShare"
                :title="`Dienstplan ${formatMonthFromKapitelDate(props.initData)} ${getYearFromKapitelDate(props.initData)}`"
            />
        </template>
    </RichResponseHeadline>
    
    <MonthCalendarForDays
        :month="startOfMonth(props.initData)"
        :days="days"
    />

</div>
</template>

<script setup lang="ts">
import RichResponseHeadline from "./components/RichResponseHeadline.vue";
import { Day} from "@/graphql/generated/graphql";
import { PropType, ref, watch} from "vue";
import { kapitelDateString } from "@/graphql/kapitelTypes";
import { DataLoader } from "@/helper/dataLoader";
import { startOfMonth, endOfMonth, formatMonthFromKapitelDate, getYearFromKapitelDate } from '@/helper/datetime/date';
import { fetchDaysForDateRange, convertDaysToTextLines } from "@/helper/day";
import {useGlobalEmitter} from "@/helper/emitter";
import MonthCalendarForDays from "@/components/MonthCalendarForDays.vue";
import ShareButton from '@/components/ShareButton.vue';

const props = defineProps({
    // month start
    initData: {
        type: String as PropType<kapitelDateString>,
        required: true
    },
    headline: {
        type: [String, null] as PropType<string|null>,
        required: false,
        default: (props:{initData:kapitelDateString}) => `${formatMonthFromKapitelDate(props.initData)} ${getYearFromKapitelDate(props.initData)}`
    }
})

const days = ref<Day[]>([])

const loader = new DataLoader(
    async () => {
        const from = startOfMonth(props.initData)
        const to = endOfMonth(from)

        days.value = await fetchDaysForDateRange(from, to)
    }
)

const init = () => {
    days.value = []
    loader.load()
}

const prepareForShare = () => {
    return convertDaysToTextLines(days.value)
}

// refresh content
useGlobalEmitter().on('day:mutated', (d) => {
    if (Object.keys(days.value).includes(d)) {
        loader.load()
    }
})


// re-init on prop change
watch(() => props.initData, init)
init()
</script>

<style scoped  lang="scss">
</style>
